import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { extHostNamedCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { MainContext } from 'vscode/vscode/vs/workbench/api/common/extHost.protocol';
import { IClipboardService } from 'vscode/vscode/vs/platform/clipboard/common/clipboardService.service';

let MainThreadClipboard = class MainThreadClipboard {
    constructor(_context, _clipboardService) {
        this._clipboardService = _clipboardService;
    }
    dispose() {
    }
    $readText() {
        return this._clipboardService.readText();
    }
    $writeText(value) {
        return this._clipboardService.writeText(value);
    }
};
MainThreadClipboard = __decorate([
    extHostNamedCustomer(MainContext.MainThreadClipboard),
    ( __param(1, IClipboardService))
], MainThreadClipboard);

export { MainThreadClipboard };
